import messages from './messages';

export type ErrorCode = Record<string, { id: string; defaultMessage: string }>;

export const calendarErrorCodes: ErrorCode = {
  CALENDAR_CUSTOMER_CALENDAR_VISIBILITY_IS_MANDATORY: messages.mandatoryCalendarVisibility,
};
